import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './PortalLayout.css';
const PortalLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === 'admin';

  const handleLogout = async () => {
    await logout();
    navigate('/portal/login');
  };

  const clientLinks = [
    { to: '/portal/dashboard', label: 'Dashboard' },
    { to: '/portal/sessions', label: 'My Sessions' },
    { to: '/portal/questions', label: 'Submit Questions' },
    { to: '/portal/resources', label: 'Training Modules' },
    { to: '/portal/plan', label: 'My Plan' },
  ];

  const adminLinks = [
    { to: '/portal/admin', label: 'Admin Dashboard' },
    { to: '/portal/admin/clients', label: 'Manage Clients' },
    { to: '/portal/admin/coaches', label: 'Manage Coaches' },
    { to: '/portal/admin/questions', label: 'Client Questions' },
    { to: '/portal/admin/sessions', label: 'Session Summaries' },
  ];

  const links = isAdmin ? adminLinks : clientLinks;

  return (
    <div className="portal-layout" data-testid="portal-layout">
      <aside className="portal-sidebar" data-testid="portal-sidebar">
        <div className="portal-sidebar-brand">
          <h2>R6&#8482;</h2>
          <span>Advisory Portal</span>
        </div>
        <nav className="portal-nav">
          {links.map(link => (
            <NavLink key={link.to} to={link.to} className={({ isActive }) => `portal-nav-link ${isActive ? 'active' : ''}`} end={link.to === '/portal/admin'}>
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div className="portal-sidebar-footer">
          <div className="portal-user-info">
            <span className="portal-user-name">{user?.name}</span>
            <span className="portal-user-role">{isAdmin ? 'Administrator' : user?.company}</span>
          </div>
          <button onClick={handleLogout} className="portal-logout-btn" data-testid="logout-btn">Sign Out</button>
          <a href="/" className="portal-back-link">Back to R6 Collective</a>
        </div>
      </aside>
      <main className="portal-main">
        <Outlet />
      </main>
    </div>
  );
};

export default PortalLayout;
